import { apiClient } from './client';

// Define types for the query parameters and response (update based on your API response structure)
interface SchoolInfoParams {
    school_id: any;
    product: string;
}

interface SchoolInfoResponse {
    schoolName: string;
    schoolLocation: string;
}

export const schoolInfoApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getSchoolInfo: builder.query<SchoolInfoResponse, SchoolInfoParams>({
            query: ({ product, school_id }) => {
                return {
                    url: `/api/config/schoolinfo?platform=${product}&schoolId=${school_id}`,
                }
            }
        }),
    }),
});

export const { useGetSchoolInfoQuery } = schoolInfoApi;
